export enum RentalStatus {
  STATUS_ONGOING = 'ongoing',
  STATUS_ENDED = 'ended',
}
